import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostListener,
} from "@angular/core";

import { SceneService } from "src/app/services/scene/scene.service";
import { BehaviorSubject } from "rxjs";
import { MenuServiceService } from "src/app/services/menu/menu-service.service";
import { MenuGeneric } from "src/app/models/menus/MenuGeneric";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MenuComponent implements OnInit {
  public currentButtonClickedObservable = new BehaviorSubject([]);
  public menuItems: MenuGeneric[];
  //private parentItem: MenuGeneric;
  public innerWidth: any;

  constructor(
    private sceneService: SceneService,
    private menuService: MenuServiceService
  ) {}

  ngOnInit() {
    this.menuItems = this.sceneService.getMenuItems();
    /*
    this.sceneService.menuChangeObservable.subscribe(message => {
      // console.log(message);
      if ("animation" === message["type"]){
        // console.log(this.menuItems)
      }
      this.menuItems.forEach(element => {
        element.maybeChange(message);
      });
    });
    */
    // this.sceneService.currentSceneObservable.subscribe((items: MenuItem[]) => {
    //   if (items.length > 0) {
    //     this.parentItem = items[0];
    //     this.menuItems = items[0].getItems();
    //   }
    this.innerWidth = window.innerWidth;

    //   // this.menuItems = items;
    // });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  debugLayerClicked() {
    // this.sceneService.debugLayer();
  }

  // childClick(item) {
  //   if (item.getButton().isClickable() && this.parentItem) {
  //     this.parentItem
  //       .getItems()
  //       .filter((currentItem) => !currentItem.parentOfChild(item))
  //       .forEach((currentChild) => currentChild.hideItems());
  //   }
  //   // this.sceneService.buttonClick(item);
  // }
}
